import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Necesito dejar de comer tortilla?',
  answer: 'No. El sistema no se basa en prohibiciones. Se basa en orden, porción y movimiento. La tortilla tiene su lugar dentro del plato visual.'
}, {
  question: '¿Sirve si ya tomo medicamento?',
  answer: 'Sí. Este plan es educativo y complementario. No sustituye tu tratamiento médico. Consulta siempre con tu doctor antes de hacer cambios.'
}, {
  question: '¿Es solo para diabetes tipo 2?',
  answer: 'Funciona para prediabetes y diabetes tipo 2. Si tienes tipo 1 o condiciones especiales, consulta con tu médico.'
}, {
  question: '¿Qué pasa si no me funciona?',
  answer: 'Tienes 7 días de garantía. Si no te aporta claridad ni un plan aplicable, te devolvemos tu dinero sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 px-4 bg-white" data-id="element-18">
      <div className="max-w-3xl mx-auto" data-id="element-19">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-20">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-22">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-23">
                <span className="font-bold text-gray-900 text-lg" data-id="element-24">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-gray-500" data-id="element-25" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-26" />}
              </button>

              <AnimatePresence data-id="element-27">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-28">
                    <div className="p-5 pt-0 bg-gray-50 text-gray-700 leading-relaxed border-t border-gray-100" data-id="element-29">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}